import { Component, Input, Output, EventEmitter, OnInit, Sanitizer, SecurityContext } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TrackerService } from '../../../plugins/tracker/services/tracker.service';
import { StateService } from '@uirouter/angular';
import * as _ from 'lodash';
import { DomSanitizer } from '@angular/platform-browser';
import { TrackeritemEditModalComponent} from '../../../plugins/tracker/edit/trackerItemEditModal/trackeritem.edit.modal.component';

@Component({
  selector: 'kanban-card',
  template: require('./kanban.card.component.html')
})
export class KanbanCardComponent implements OnInit {
  @Input() trackeritem: any; // Replace 'any' with appropriate type for trackeritem.
  @Input() tracker: any; // Replace 'any' with appropriate type for tracker.
  @Input() showClosedStatus: boolean = false; // Set the appropriate default value for showClosedStatus.
  @Input() allowModal: boolean = true; // Set the appropriate default value for allowModal.

  @Output() onDelete: EventEmitter<any> = new EventEmitter<any>();

  protected sanitizedDetails: any = '';
  modalRef: any;

  constructor(
    private modalService: NgbModal,
    private trackerService: TrackerService,
    private stateService: StateService,
    private domSanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    if (this.allowModal === undefined) {
      this.allowModal = true;
    }
    this.sanitizedDetails = this.domSanitizer.sanitize(
      SecurityContext.HTML,
      this.trackeritem?.details?.trim()
    );
  }

  showEditModal(): void {
    const modalRef = this.modalService.open(TrackeritemEditModalComponent);
    modalRef.componentInstance.tracker = this.trackeritem.tracker;
    modalRef.componentInstance.trackeritem = this.trackeritem;
    modalRef.componentInstance.allowUpdate =  _.has(this.trackeritem, 'canUpdate')
      ? this.trackeritem.canUpdate
      : this.trackerService.acl.canUpdate(this.tracker);
    modalRef.componentInstance.allowAssignments = this.trackeritem.canAssign;
    modalRef.componentInstance.onUpdate.subscribe(() => {
	    modalRef.close();
    });
    modalRef.componentInstance.onCancel.subscribe(() => {
	    modalRef.close();
    });
    modalRef.componentInstance.onDelete.subscribe((trackeritem) => {
      this.onDelete.emit(trackeritem);
	    modalRef.close();
    });
	};

  goToTrackeritemEdit(params: any = {}) {
    this.stateService.go('home.project.summary.tracker.item.edit', params);
  }
}
